import {MyopMessages} from "../../common/MyopMessages";
import {SetAttributeMessage} from "../../messages";
import {BaseWebComponentMessageHandler} from "./BaseWebComponentMessageHandler.ts";
import {ShadowRootRef} from "../shadowRootRef.ts";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class setAttributeHandler extends BaseWebComponentMessageHandler<SetAttributeMessage> {

    messageType = MyopMessages.SetAttributeMessage;

    innerExecutor = (event: SetAttributeMessage, shadowRootRef: ShadowRootRef) => {
        const items = getElementsByRef(event.ref, shadowRootRef.shadowRoot);
        items.forEach(item => {
            item.setAttribute(event.name, event.value)
        })
    }
}
